// Service markers in the texts of collected messages (tasks parsers, TelegramWebParser):
//   {{LINK:url|text}}            a link; the text may be empty
//   {{BLOCKQUOTE:text}}          a quote; may hold links and line breaks, may be empty
//   ___LINE_BREAK___, _LINE_BREAK_, ___MENTION_N___, __MENTION_N__MENTION_   old ones
//   any other {{KIND...}} and a marker cut off at the end are dropped
// On 21.10.2026 the previews kept {{BLOCKQUOTE:}} of empty quotes and the message windows
// kept multi-line quotes: every view takes the rules from here.

const LINK = /\{\{LINK:[^|}]*\|([^{}]*)\}\}/g;
const QUOTE = /\{\{BLOCKQUOTE:([^{}]*)\}\}/g;      // innermost first: links are gone by then
const OTHER = /\{\{[A-Z_]+(?::[^{}]*)?\}\}/g;
const CUT = /\{\{[A-Z_]*(?::[^}]*)?$/;
const OLD_BREAK = /___LINE_BREAK___|_LINE_BREAK_/g;
const OLD_MENTION = /___MENTION_\d+___|__MENTION_\d+__MENTION_/g;

// Plain text: link texts and quote texts kept, everything else of the markers dropped.
// ES highlight tags (<em>) are kept for the caller.
export function markersToText(value) {
  let text = value == null ? '' : String(value);
  text = text.replace(LINK, '$1');
  let before;
  do {
    before = text;
    text = text.replace(QUOTE, '$1 ');
  } while (text !== before);
  return text
    .replace(OTHER, '')
    .replace(CUT, '')
    .replace(OLD_BREAK, ' ')
    .replace(OLD_MENTION, '');
}

// For the HTML views: the quote pattern that spans line breaks (the HTML of a view has its
// links and breaks in place by then).
export const QUOTE_HTML = /\{\{BLOCKQUOTE:([\s\S]*?)\}\}/g;

export default markersToText;

// The last step of the HTML views: markers no rule above turned into HTML (an unknown kind,
// one cut off at the end) are dropped instead of being shown.
export function dropLeftoverMarkers(html) {
  return (html == null ? '' : String(html)).replace(OTHER, '').replace(CUT, '');
}
